export default [
    {
        path: '/clicks',
        name: 'PageClicksList',
        meta: { title: 'clicks.listTitle', roles: ['ADMIN', 'TEAM_LEADER'], permissions: ['click'] },
        component: () => import('@/pages/clicks'),
    },
]